import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import "./tsyleblog.css"; // CSS pour le blog

// Posts du blog avec PDF lié à chaque post
const initialPosts = [
  {
    id: 1,
    title: "Apprentissage supervisé de flux de trésorerie",
    excerpt: "Il y a quelque temps, j'ai repris ce projet avec l'objectif d'y intégrer l'Intelligence Artificielle afin de prédire, grâce aux données des flux d’entrée et de sortie, à quel moment l'entreprise risque de se retrouver en pénurie de liquidités. Il permet également de prédire le meilleur moment pour envoyer automatiquement des rappels de paiement de facture",
    author: "Giresse M. KIFOUANI",
    date: "17 septembre 2024",
    image: "/documentpdf/images/apprentisage.png",
    pdf: "/documentpdf/Apprentissage_supervis_du_flux_de_tr_sorerie_1757936534.pdf"
  }
];

const particleOptions = {
  background: { color: { value: "#007bff" } },
  particles: {
    number: { value: 50 },
    shape: { type: "circle" },
    opacity: { value: 0.5, random: true },
    size: { value: 3, random: true },
    move: { enable: true, speed: 2 },
  },
  interactivity: {
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "push" },
    },
  },
};

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [activeLink, setActiveLink] = useState("blog");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setPosts(initialPosts); // Charge les posts
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY >= 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => setActiveLink(value);
  const particlesInit = async (main) => await loadFull(main);

  return (
    <div className="blog-page">


      {/* Navbar */}
      <Navbar expand="lg" fixed="top" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            className={activeLink === "blog" ? "active navbar-link" : "navbar-link"}
            onClick={() => onUpdateActiveLink("blog")}
          >
            Giresse KIFOUANI
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/"
                className={activeLink === "blog" ? "active navbar-link" : "navbar-link"}
                onClick={() => onUpdateActiveLink("blog")}
              >
                Accueil
              </Nav.Link>
            </Nav>
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/blog"
                className={activeLink === "blog" ? "active navbar-link" : "navbar-link"}
                onClick={() => onUpdateActiveLink("blog")}
              >
                Blog
              </Nav.Link>
            </Nav>
          
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Contenu du blog */}
      <Container className="blog-container" style={{ paddingTop: "120px" }}>
        <h1 className="text-center mb-5">Mon Blog</h1>
        <div className="posts-grid">
          {posts.map((post) => (
            <div key={post.id} className="post-card">
              <img src={post.image} alt={post.title} />
              <div className="post-content">
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <div className="post-meta">
                  <span>Par {post.author}</span>
                  <span>{post.date}</span>
                </div>
                {/* Lien PDF unique par post */}
                {post.pdf && (
                  <a
                    href={post.pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="read-more"
                  >
                    Lire la suite
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Blog;
